import React, { useContext } from "react";
import { EditTenantContext } from "../EditTenantView";
import { Col, Container, Row } from "react-bootstrap";
import ContentData from "../../../../constants/contentFile.json";
import InputComponent from "../../../../components/InputComponent/InputComponent";
import "./editTenant.css";
import RouteConstants from "../../../../constants/routeConstants.json";

import BorderButton from "../../../../components/BorderButton/BorderButton";
import ThemeButton from "../../../../components/ThemeButton/ThemeButton";
import Loader from "../../../../components/Loader/Loader";
import TenantDetailsErrorPopup from "../../../../components/PopupAlertError/PopupAlertError";
import NextIcon from "../../../../assets/images/next-icon.svg";
import SelectOption from "../../../../components/ThemeSelectOption/SelectOption";
import EditSuccessPopup from "../../../../components/PopupAlertSuccess/PopupAlert";
import EditErrorPopup from "../../../../components/PopupAlertError/PopupAlertError";

const EditTenant = () => {
  const {
    spinnerStatus,
    tenantName,
    tenantEmail,
    tenantPhone,
    tenantOrgName,
    tenantOrgEmail,
    tenantOrgType,
    tenantLocation,
    tenantStatus,
    subscriptionPlan,
    errorPopup,
    setErrorPopup,
    errorAlertMessage,
    adminId,
    viewTenantDetails,
    goToTenantViewPage,
    onChangeOrgName,
    onChangePhone,
    onChangeOrgEmail,
    onChangeOrgType,
    onChangeLocation,
    onChangeSubsriptionPlan,
    transformedPlans,
    handleBlur,
    validationErrors,
    editTenantDetails,
    editSuccessPopup,
    setEditSuccessPopup,
    editErrorPopup,
    setEditErrorPopup,
    goToTenantList,
    errorPopupMessage,
    setErrorPopupMessage,
    buttonText,
    setButtonText,
    goToLogin,
    statusValue,
    setStatusValue,
  } = useContext(EditTenantContext);

  // console.log("subscriptionPlan", subscriptionPlan);
  return (
    <div className="pageBg">
      <div className="breadCrums">
        <span className="breadCrumsPointing" onClick={goToTenantList}>
          {ContentData.editTenant.tenantManagement}
        </span>
        <img className="nextIcon" src={NextIcon} alt="next icon" />
        <span
          className="breadCrumsPointing"
          onClick={() => {
            goToTenantViewPage(adminId);
          }}
        >
          {ContentData.editTenant.viewTenant}
        </span>
        <img className="nextIcon" src={NextIcon} alt="next icon" />
        <span className="boldBreadCrums">
          {ContentData.editTenant.pageTitle}
        </span>
      </div>
      {spinnerStatus && <Loader />}
      <Container className="editTenantContainer">
        <div className="pageTittles">{ContentData.editTenant.pageTitle}</div>

        <form action="" onSubmit={editTenantDetails}>
          <div className="basicContainer">
            <Row>
              <Col xl="4" lg="6" sm="12">
                <div className="adminDetailSection">
                  <div className="adminDetailSectionTop roleSubPage">
                    <h4>{ContentData.editTenant.fullName}</h4>
                    <InputComponent
                      placeholder={ContentData.editTenant.enterName}
                      value={tenantName}
                      disabled={true}
                    />
                    {validationErrors.name && (
                      <p className="mb-0 error-msg">{validationErrors.name}</p>
                    )}
                  </div>
                </div>
              </Col>
              <Col xl="4" lg="6" sm="12">
                <div className="adminDetailSection">
                  <div className="adminDetailSectionTop roleSubPage">
                    <h4>{ContentData.editTenant.emailAddress}</h4>
                    <InputComponent
                      placeholder={ContentData.editTenant.enteremail}
                      value={tenantEmail}
                      disabled={true}
                    />
                    {validationErrors.email && (
                      <p className="mb-0 error-msg">{validationErrors.email}</p>
                    )}
                  </div>
                </div>
              </Col>
              <Col xl="4" lg="6" sm="12">
                <div className="adminDetailSection">
                  <div className="adminDetailSectionTop roleSubPage">
                    <h4>{ContentData.editTenant.phoneNumber}</h4>
                    <InputComponent
                      placeholder={ContentData.editTenant.enterPhoneNmber}
                      value={tenantPhone}
                      onChange={onChangePhone}
                      handleBlur={() => handleBlur("phone")}
                    />
                    {validationErrors.phone && (
                      <p className="mb-0 error-msg">{validationErrors.phone}</p>
                    )}
                  </div>
                </div>
              </Col>
            </Row>
            <div className="organisationDetailsEditTenant">
              {ContentData.editTenant.organisationDetails}
            </div>
            <Row>
              <Col xl="4" lg="6" sm="12">
                <div className="adminDetailSection">
                  <div className="adminDetailSectionTop roleSubPage">
                    <h4>{ContentData.editTenant.name}</h4>
                    <InputComponent
                      placeholder={ContentData.editTenant.enterName}
                      value={tenantOrgName}
                      onChange={onChangeOrgName}
                      handleBlur={() => handleBlur("organizationName")}
                    />
                    {validationErrors.organizationName && (
                      <p className="mb-0 error-msg">
                        {validationErrors.organizationName}
                      </p>
                    )}
                  </div>
                </div>
              </Col>
              <Col xl="4" lg="6" sm="12">
                <div className="adminDetailSection">
                  <div className="adminDetailSectionTop roleSubPage">
                    <h4>{ContentData.editTenant.emailAddress}</h4>
                    <InputComponent
                      placeholder={ContentData.editTenant.enteremail}
                      value={tenantOrgEmail}
                      handleBlur={() => handleBlur("organizationEmail")}
                      onChange={onChangeOrgEmail}
                    />
                    {validationErrors.organizationEmail && (
                      <p className="mb-0 error-msg">
                        {validationErrors.organizationEmail}
                      </p>
                    )}
                  </div>
                </div>
              </Col>
              <Col xl="4" lg="6" sm="12">
                <div className="adminDetailSection">
                  <div className="adminDetailSectionTop roleSubPage">
                    <h4>{ContentData.editTenant.type}</h4>
                    <InputComponent
                      placeholder={ContentData.editTenant.enterOrganizationType}
                      value={tenantOrgType}
                      handleBlur={() => handleBlur("organizationType")}
                      onChange={onChangeOrgType}
                    />
                    {validationErrors.organizationType && (
                      <p className="mb-0 error-msg">
                        {validationErrors.organizationType}
                      </p>
                    )}
                  </div>
                </div>
              </Col>
            </Row>
            <Row>
              <Col xl="4" lg="6" sm="12">
                <div className="adminDetailSection">
                  <div className="adminDetailSectionTop roleSubPage">
                    <h4>{ContentData.editTenant.location}</h4>
                    <InputComponent
                      placeholder={ContentData.editTenant.enterLocation}
                      value={tenantLocation}
                      handleBlur={() => handleBlur("location")}
                      onChange={onChangeLocation}
                    />
                    {validationErrors.location && (
                      <p className="mb-0 error-msg">
                        {validationErrors.location}
                      </p>
                    )}
                  </div>
                </div>
              </Col>
            </Row>
            <div className="organisationDetailsEditTenant">
              {ContentData.editTenant.subscriptionDetails}
            </div>
            <Row>
              <Col xl="4" lg="6" sm="12">
                <div className="adminDetailSection">
                  <div className="adminDetailSectionTop roleSubPage">
                    <h4>{ContentData.editTenant.subscriptionPlan}</h4>
                    <SelectOption
                      values={transformedPlans}
                      handleSelectData={onChangeSubsriptionPlan}
                      selectNum="id"
                      label="displayName"
                      defaultValue={subscriptionPlan || ""}
                      selectPlaceholder="Select a Plan"
                      handleBlur={() => handleBlur("subscriptionPlan")}
                      style={{ marginBottom: "20px" }}
                    />
                    {validationErrors.subscriptionPlan && (
                      <p className="mb-0 error-msg">
                        {validationErrors.subscriptionPlan}
                      </p>
                    )}
                  </div>
                </div>
              </Col>
            </Row>
            <div className="editTenantBtnGrp">
              <BorderButton
                value={ContentData.editTenant.cancel}
                onClick={() => goToTenantViewPage(adminId)}
              />
              <ThemeButton
                value={ContentData.editTenant.submit}
                id="submitTenantEditBtn"
                type="submit"
              />
            </div>
          </div>
        </form>
      </Container>
      <EditSuccessPopup
        show={editSuccessPopup}
        setShow={setEditSuccessPopup}
        alertMessage={errorAlertMessage}
        handleSubmit={() => goToTenantViewPage(adminId)}
      />
      <TenantDetailsErrorPopup
        show={errorPopup}
        setShow={setErrorPopup}
        alertMessage={errorAlertMessage}
        handleCancel={() => {
          setErrorPopup(false);
          goToTenantViewPage(adminId);
        }}
        handleSubmit={() => {
          if (statusValue === 401 || statusValue === 403) {
            goToLogin();
            setErrorPopup(false);
          } else {
            setErrorPopup(false);
            viewTenantDetails(adminId);
          }
        }}
        cancelText={ContentData.tenantPage.cancel}
        buttonText={buttonText}
      />
      <EditErrorPopup
        show={editErrorPopup}
        setShow={setEditErrorPopup}
        alertMessage={errorAlertMessage}
        handleCancel={() => {
          setEditErrorPopup(false);
        }}
        handleSubmit={() => {
          setEditErrorPopup(false);
          document.getElementById("submitTenantEditBtn").click();
        }}
        cancelText={ContentData.tenantPage.cancel}
        buttonText={ContentData.tenantPage.tryAgain}
      />
    </div>
  );
};

export default EditTenant;
